import _isArray from 'lodash/isArray'

import { mixpanelIdentify, mixpanelPeopleSet, mixpanelReset, mixpanelTrack } from '@scouts/helpers'

import { ONBOARDING_SERVICE_QUARTERLY_TAX_RETURN, ONBOARDING_SERVICE_TAX_REGISTRATION } from './constants'
import { getIsNIE, obscureSensitiveData, TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_UNKNOWN } from './domain/tax-office'
import { chunkString } from './helpers/strings'

const CATEGORY_USER = 'USER'
const CATEGORY_SUBSCRIPTION = 'SUBSCRIPTION'
const CATEGORY_TAX_REGISTRATION = 'TAX_REGISTRATION'
const CATEGORY_QUARTERLY_TAX_RETURN = 'QUARTERLY_TAX_RETURN'
const CATEGORY_TAX_RETURN = 'TAX_RETURN'
const CATEGORY_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'

export const TRACK_USER_AUTHENTICATE = 'USER_AUTHENTICATE'
export const TRACK_USER_LOGOUT = 'USER_LOGOUT'
export const TRACK_USER_RESET_SESSION = 'USER_RESET_SESSION'
export const TRACK_USER_SIGNUP = 'USER_SIGNUP'

export const TRACK_ONBOARDING_TAX_REGISTRATION_SELECT = 'ONBOARDING_TAX_REGISTRATION_SELECT'
export const TRACK_ONBOARDING_QUARTERLY_TAX_RETURN_SELECT = 'ONBOARDING_QUARTERLY_TAX_RETURN_SELECT'

export const TRACK_ONBOARDING_MATCH_WITH_ACCOUNTANT = 'MATCH_ACCOUNTANT_LINK_CLICKED'

export const TRACK_TAX_REGISTRATION_START = 'TAX_REGISTRATION_START'
export const TRACK_TAX_REGISTRATION_SUBMIT = 'TAX_REGISTRATION_SUBMIT'

export const TRACK_SOCIAL_SECURITY_REGISTRATION_START = 'SOCIAL_SECURITY_REGISTRATION_START'
export const TRACK_SOCIAL_SECURITY_REGISTRATION_SUBMIT = 'SOCIAL_SECURITY_REGISTRATION_SUBMIT'

export const TRACK_QUARTERLY_TAX_RETURN_START = 'QUARTERLY_TAX_RETURN_START'
export const TRACK_QUARTERLY_TAX_RETURN_SUBMIT = 'QUARTERLY_TAX_RETURN_SUBMIT'

export const TRACK_SUBSCRIPTION_INITIATE_PAYMENT = 'SUBSCRIPTION_INITIATE_PAYMENT'
export const TRACK_SUBSCRIPTION_COMPLETE_PAYMENT = 'SUBSCRIPTION_COMPLETE_PAYMENT'
export const TRACK_SUBSCRIPTION_CANCEL_PAYMENT = 'SUBSCRIPTION_CANCEL_PAYMENT'

export const TRACK_SUBSCRIPTION_CANCELLATION = 'SUBSCRIPTION_CANCELLATION'

export const TRACK_REQUEST_CLAVE_PIN_SUCCESS = 'REQUEST_CLAVE_PIN_SUCCESS'
export const TRACK_REQUEST_CLAVE_PIN_FAILURE = 'REQUEST_CLAVE_PIN_FAILURE'

export const TRACK_TAX_RETURN_START = 'TAX_RETURN_START'
export const TAX_RETURN_AUTHENTICATION_IDENTIFICATION_FORM_ACTION =
    'TAX_RETURN_AUTHENTICATION_IDENTIFICATION_FORM_ACTION'
export const TRACK_TAX_RETURN_AUTHENTICATION_IDENTIFICATION_COMPLETED =
    'TAX_RETURN_AUTHENTICATION_IDENTIFICATION_COMPLETED'
export const TRACK_TAX_RETURN_AUTHENTICATION_REVIEW_COMPLETED = 'TAX_RETURN_AUTHENTICATION_REVIEW_COMPLETED'
export const TRACK_TAX_RETURN_AUTHENTICATION_REVIEW_ADDRESS_COMPLETED =
    'TAX_RETURN_AUTHENTICATION_REVIEW_ADDRESS_COMPLETED'
export const TRACK_TAX_RETURN_AUTHENTICATION_METHOD_PROMPT = 'TAX_RETURN_AUTHENTICATION_METHOD_PROMPT'
export const TRACK_TAX_RETURN_AUTHENTICATION_REQUEST = 'TAX_RETURN_AUTHENTICATION_REQUEST'
export const TRACK_TAX_RETURN_AUTHENTICATION_SUCCESS = 'TAX_RETURN_AUTHENTICATION_SUCCESS'
export const TRACK_TAX_RETURN_AUTHENTICATION_FAILURE = 'TAX_RETURN_AUTHENTICATION_FAILURE'
export const TRACK_TAX_RETURN_AUTHENTICATION_PROMPT_DATE_OF_BIRTH = 'TAX_RETURN_AUTHENTICATION_PROMPT_DATE_OF_BIRTH'
export const TRACK_TAX_RETURN_PROMPT_ADDRESS_CONFIRMATION = 'TAX_RETURN_PROMPT_ADDRESS_CONFIRMATION'
export const TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_SUCCESS = 'TAX_RETURN_ADDRESS_CONFIRMATION_SUCCESS'
export const TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_ERROR = 'TAX_RETURN_ADDRESS_CONFIRMATION_ERROR'
export const TRACK_TAX_RETURN_MISSING_CADASTRAL_REFERENCE_ERROR = 'TAX_RETURN_CADASTRAL_MISSING_ERROR'
export const TRACK_TAX_RETURN_COMPLETE_DATA_SYNC = 'TAX_RETURN_COMPLETE_DATA_SYNC'
export const TRACK_TAX_RETURN_SUBMIT = 'TAX_RETURN_SUBMIT'
export const TRACK_TAX_RETURN_INITIATE_PAYMENT = 'TAX_RETURN_INITIATE_PAYMENT'
export const TRACK_TAX_RETURN_COMPLETE_PAYMENT = 'TAX_RETURN_COMPLETE_PAYMENT'
export const TRACK_TAX_RETURN_CANCEL_PAYMENT = 'TAX_RETURN_CANCEL_PAYMENT'

export const TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START = 'QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START'
export const TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_SUBMIT = 'QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_SUBMIT'
export const TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_INITIATE_PAYMENT =
    'QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_INITIATE_PAYMENT'
export const TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_COMPLETE_PAYMENT =
    'QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_COMPLETE_PAYMENT'
export const TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_CANCEL_PAYMENT =
    'QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_CANCEL_PAYMENT'
export const TRACK_QUARTERLY_TAX_RETURNS_UPLOAD_SPREADSHEET = 'QUARTERLY_TAX_RETURNS_UPLOAD_SPREADSHEET'

export const TRACK_INVOICE_CREATE = 'INVOICE_CREATE'
export const TRACK_INVOICE_DELETE = 'INVOICE_DELETE'
export const TRACK_INVOICE_DOWNLOAD = 'INVOICE_DOWNLOAD'
export const TRACK_INVOICE_SAVE = 'INVOICE_SAVE'

export const TRACK_VIEW_PAGE = 'VIEW_PAGE'

export const TRACKING_ACTION_FOCUS = 'Focus'
export const TRACKING_ACTION_SET_VALUE = 'SetValue'

export const TRACK_WHATS_NEXT_TOOGGLE = 'WHATS_NEXT_TOOGGLE'
export const TRACK_WHATS_NEXT_LINK_CLICKED = 'WHATS_NEXT_LINK_CLICKED'

export const TRACK_SUBSCRTIPTION_UPDATE = 'TRACK_SUBSCRTIPTION_UPDATE'

export const TRACK_BANKING_BBVA_CTA_CLICK = 'BANKING_BBVA_CTA_CLICK'

/**
 * Mixpanel limits strings to 255 characters, but we sometimes want to send more data.
 * Mixpanel does take lists of up to 8KB, with a 255B limit for each item.
 * Assuming UTF-8 encoding, 255B = 255 characters.
 */
const chunkStringInPiecesOfLength255 = chunkString(255)

const googleAnalyticsTrack = (event = {}) => {
    if (_isArray(window.dataLayer) && event.category && event.action) {
        const fields = {
            ...event,
            event: 'GAEvent',
            eventCategory: event.category,
            eventAction: event.action,
            eventLabel: event.label ? event.label : undefined,
            eventValue: event.value ? event.value : undefined,
        }
        window.dataLayer.push(fields)
    }
}

export const track = (action, data = {}) => {
    switch (action) {
        case TRACK_VIEW_PAGE: {
            const { profile, pathname, hash, search } = data

            const {
                isNewSelfEmployed,
                isSelfEmployed,
                latestSubscription, // @TODO: Use `subscriptionStatus` from the enhanced profile (passed from LocationObserver) once it's safe to use `profileSelector` outside `Authentication`
                referralSource,
                selfDeclaredAttributionSource,
                supportNumber,
                taxRegistrationStatus,
                uniqueTaxpayerReference,
                variant,
                initialVariant,
                languagePreference,
            } = profile

            mixpanelPeopleSet({
                Variant: variant,
                'Initial Variant': initialVariant,
                'Is New Self-employed': isNewSelfEmployed,
                'Is Self-employed': isSelfEmployed,
                'Subscription Status': latestSubscription?.status,
                'Tax Registration Status': taxRegistrationStatus,
                'Referral Source': referralSource,
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
                'Support Number': obscureSensitiveData(supportNumber, { replaceNumbersWith: 0 }),
                'Self-declared Attribution Source': selfDeclaredAttributionSource,
                'Language Preference': languagePreference,
            })

            mixpanelTrack(TRACK_VIEW_PAGE, { Path: `/app${pathname}`, Hash: hash, Search: search })

            break
        }

        case TRACK_USER_AUTHENTICATE: {
            const {
                userId,
                variant,
                initialVariant,
                isNewSelfEmployed,
                isSelfEmployed,
                referralSource,
                languagePreference,
            } = data

            mixpanelIdentify(userId)

            mixpanelPeopleSet({
                Variant: variant,
                'Initial Variant': initialVariant,
                'Is New Self-employed': isNewSelfEmployed,
                'Is Self-employed': isSelfEmployed,
                'Referral Source': referralSource,
                'Language Preference': languagePreference,
            })

            mixpanelTrack(TRACK_USER_AUTHENTICATE)

            break
        }

        case TRACK_USER_SIGNUP: {
            const { variant, initialVariant, isSelfEmployed, isNewSelfEmployed, referralSource, languagePreference } =
                data

            googleAnalyticsTrack({
                category: CATEGORY_USER,
                action: TRACK_USER_SIGNUP,
                label: variant,
                languagePreference,
            })

            mixpanelPeopleSet({
                Variant: variant,
                'Initial Variant': initialVariant,
                'Is New Self-employed': isNewSelfEmployed,
                'Is Self-employed': isSelfEmployed,
                'Referral Source': referralSource,
                'Language Preference': languagePreference,
            })

            mixpanelTrack(TRACK_USER_SIGNUP)

            break
        }

        case TRACK_USER_LOGOUT: {
            mixpanelTrack(TRACK_USER_LOGOUT)

            break
        }

        case TRACK_USER_RESET_SESSION: {
            mixpanelTrack(TRACK_USER_RESET_SESSION)

            break
        }

        case TRACK_ONBOARDING_TAX_REGISTRATION_SELECT: {
            mixpanelTrack(TRACK_ONBOARDING_TAX_REGISTRATION_SELECT)

            break
        }

        case TRACK_ONBOARDING_QUARTERLY_TAX_RETURN_SELECT: {
            mixpanelTrack(TRACK_ONBOARDING_QUARTERLY_TAX_RETURN_SELECT)

            break
        }

        case TRACK_ONBOARDING_MATCH_WITH_ACCOUNTANT: {
            mixpanelTrack(TRACK_ONBOARDING_MATCH_WITH_ACCOUNTANT)

            break
        }

        case TRACK_SUBSCRIPTION_INITIATE_PAYMENT: {
            const { isNewSelfEmployed } = data

            googleAnalyticsTrack({
                category: CATEGORY_SUBSCRIPTION,
                action: TRACK_SUBSCRIPTION_INITIATE_PAYMENT,
                label: isNewSelfEmployed
                    ? ONBOARDING_SERVICE_TAX_REGISTRATION
                    : ONBOARDING_SERVICE_QUARTERLY_TAX_RETURN,
            })

            mixpanelTrack(TRACK_SUBSCRIPTION_INITIATE_PAYMENT)

            break
        }

        case TRACK_SUBSCRIPTION_COMPLETE_PAYMENT: {
            const { isNewSelfEmployed, subscriptionTierType, languagePreference } = data

            googleAnalyticsTrack({
                ...data,
                category: CATEGORY_SUBSCRIPTION,
                action: TRACK_SUBSCRIPTION_COMPLETE_PAYMENT,
                label: isNewSelfEmployed
                    ? ONBOARDING_SERVICE_QUARTERLY_TAX_RETURN
                    : ONBOARDING_SERVICE_TAX_REGISTRATION,
                subscriptionTierType,
                languagePreference,
            })

            mixpanelTrack(TRACK_SUBSCRIPTION_COMPLETE_PAYMENT, data)

            break
        }

        case TRACK_SUBSCRIPTION_CANCEL_PAYMENT: {
            const { isNewSelfEmployed } = data

            googleAnalyticsTrack({
                category: CATEGORY_SUBSCRIPTION,
                action: TRACK_SUBSCRIPTION_CANCEL_PAYMENT,
                label: isNewSelfEmployed
                    ? ONBOARDING_SERVICE_QUARTERLY_TAX_RETURN
                    : ONBOARDING_SERVICE_TAX_REGISTRATION,
            })

            mixpanelTrack(TRACK_SUBSCRIPTION_CANCEL_PAYMENT)

            break
        }

        case TRACK_SUBSCRIPTION_CANCELLATION: {
            const {
                abCancellationReasonTypesList = [],
                cancellationReasonTypeHistory = [],
                isAccountantMistakeHistory = [],
                cancellationReasonDescription = '',
                type,
                ...rest
            } = data

            const event = {
                'A/B Cancellation Reasons List': abCancellationReasonTypesList.join(', '),
                'Reason Type History': cancellationReasonTypeHistory.filter((h) => h != null).join(', '),
                'Is Accountant Mistake History': isAccountantMistakeHistory.filter((h) => h != null).join(', '),
                'Cancellation Reason Description': chunkStringInPiecesOfLength255(cancellationReasonDescription),
                Type: type,
                ...rest,
            }

            googleAnalyticsTrack({
                category: CATEGORY_SUBSCRIPTION,
                action: TRACK_SUBSCRIPTION_CANCEL_PAYMENT,
                label: type,
            })

            mixpanelTrack(TRACK_SUBSCRIPTION_CANCELLATION, event)

            break
        }

        case TRACK_TAX_REGISTRATION_START: {
            googleAnalyticsTrack({
                category: CATEGORY_TAX_REGISTRATION,
                action: TRACK_TAX_REGISTRATION_START,
            })

            mixpanelTrack(TRACK_TAX_REGISTRATION_START)

            break
        }

        case TRACK_TAX_REGISTRATION_SUBMIT: {
            googleAnalyticsTrack({
                category: CATEGORY_TAX_REGISTRATION,
                action: TRACK_TAX_REGISTRATION_SUBMIT,
            })

            mixpanelTrack(TRACK_TAX_REGISTRATION_SUBMIT)

            break
        }

        case TRACK_SOCIAL_SECURITY_REGISTRATION_START: {
            googleAnalyticsTrack({
                category: CATEGORY_TAX_REGISTRATION,
                action: TRACK_SOCIAL_SECURITY_REGISTRATION_START,
            })

            mixpanelTrack(TRACK_SOCIAL_SECURITY_REGISTRATION_START)

            break
        }

        case TRACK_SOCIAL_SECURITY_REGISTRATION_SUBMIT: {
            googleAnalyticsTrack({
                category: CATEGORY_TAX_REGISTRATION,
                action: TRACK_SOCIAL_SECURITY_REGISTRATION_SUBMIT,
            })

            mixpanelTrack(TRACK_SOCIAL_SECURITY_REGISTRATION_SUBMIT)

            break
        }

        case TRACK_QUARTERLY_TAX_RETURN_START: {
            const { taxYear, quarter } = data

            googleAnalyticsTrack({
                category: CATEGORY_QUARTERLY_TAX_RETURN,
                action: TRACK_QUARTERLY_TAX_RETURN_START,
                label: `${taxYear} ${quarter}`,
            })

            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURN_START, {
                'Tax Year': taxYear,
                Quarter: quarter,
            })

            break
        }

        case TRACK_QUARTERLY_TAX_RETURN_SUBMIT: {
            const { taxYear, quarter } = data

            googleAnalyticsTrack({
                category: CATEGORY_QUARTERLY_TAX_RETURN,
                action: TRACK_QUARTERLY_TAX_RETURN_SUBMIT,
                label: `${taxYear} ${quarter}`,
            })

            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURN_SUBMIT, {
                'Tax Year': taxYear,
                Quarter: quarter,
            })

            break
        }

        case TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
                action: TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START,
                label: taxYear,
            })

            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_INITIATE_PAYMENT: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
                action: TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_INITIATE_PAYMENT,
                label: taxYear,
            })

            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_INITIATE_PAYMENT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_COMPLETE_PAYMENT: {
            const { amount /* , quarterlyTaxReturnsAnnualSummaryId, */, taxYear /* , userId */, languagePreference } =
                data

            googleAnalyticsTrack({
                ...data,
                category: CATEGORY_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
                action: TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_COMPLETE_PAYMENT,
                label: taxYear,
                value: amount,
                languagePreference,
            })

            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_COMPLETE_PAYMENT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_CANCEL_PAYMENT: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
                action: TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_CANCEL_PAYMENT,
                label: taxYear,
            })

            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_CANCEL_PAYMENT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_SUBMIT: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
                action: TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_SUBMIT,
                label: taxYear,
            })

            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_SUBMIT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_QUARTERLY_TAX_RETURNS_UPLOAD_SPREADSHEET: {
            mixpanelTrack(TRACK_QUARTERLY_TAX_RETURNS_UPLOAD_SPREADSHEET)
            break
        }

        case TRACK_TAX_RETURN_START: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_START,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_START, {
                'Tax Year': taxYear,
            })

            break
        }

        case TAX_RETURN_AUTHENTICATION_IDENTIFICATION_FORM_ACTION: {
            const { intent, formField, value } = data

            mixpanelTrack(TAX_RETURN_AUTHENTICATION_IDENTIFICATION_FORM_ACTION, {
                'Form Field Name': formField,
                ...(value
                    ? {
                          'Form Field Value': obscureSensitiveData(value, {
                              replaceNumbersWith: 0,
                          }),
                      }
                    : undefined),
                Action: intent,
            })

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_IDENTIFICATION_COMPLETED: {
            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_IDENTIFICATION_COMPLETED)

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_REVIEW_COMPLETED: {
            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_REVIEW_COMPLETED)

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_REVIEW_ADDRESS_COMPLETED: {
            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_REVIEW_ADDRESS_COMPLETED)

            break
        }

        case TRACK_REQUEST_CLAVE_PIN_SUCCESS: {
            const { uniqueTaxpayerReference } = data

            mixpanelTrack(TRACK_REQUEST_CLAVE_PIN_SUCCESS, {
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
            })

            break
        }

        case TRACK_REQUEST_CLAVE_PIN_FAILURE: {
            const { errorType, supportNumber, uniqueTaxpayerReference } = data

            mixpanelTrack(TRACK_REQUEST_CLAVE_PIN_FAILURE, {
                'Error Type': errorType || TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_UNKNOWN,
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                'Support Number': obscureSensitiveData(supportNumber, { replaceNumbersWith: 0 }),
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
            })

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_METHOD_PROMPT: {
            const { taxYear, authenticationMethod, isIbanAuthentication, uniqueTaxpayerReference } = data

            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_METHOD_PROMPT, {
                'Authentication Method': authenticationMethod,
                'Is IBAN Authentication': isIbanAuthentication,
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                'Tax Year': taxYear,
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
            })

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_PROMPT_DATE_OF_BIRTH: {
            const { errorType, taxYear, uniqueTaxpayerReference } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_AUTHENTICATION_PROMPT_DATE_OF_BIRTH,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_PROMPT_DATE_OF_BIRTH, {
                'Error Type': errorType || TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_UNKNOWN,
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                'Tax Year': taxYear,
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
            })

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_REQUEST: {
            const { taxYear, authenticationMethod, isIbanAuthentication, uniqueTaxpayerReference } = data

            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_REQUEST, {
                'Tax Year': taxYear,
                'Authentication Method': authenticationMethod,
                'Is IBAN Authentication': isIbanAuthentication,
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
            })

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_SUCCESS: {
            const { taxYear, authenticationMethod, isIbanAuthentication, uniqueTaxpayerReference } = data

            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_SUCCESS, {
                'Tax Year': taxYear,
                'Authentication Method': authenticationMethod,
                'Is IBAN Authentication': isIbanAuthentication,
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
            })

            break
        }

        case TRACK_TAX_RETURN_AUTHENTICATION_FAILURE: {
            const {
                authenticationMethod,
                errorType,
                isIbanAuthentication,
                supportNumber,
                taxYear,
                uniqueTaxpayerReference,
            } = data

            mixpanelTrack(TRACK_TAX_RETURN_AUTHENTICATION_FAILURE, {
                'Authentication Method': authenticationMethod,
                'Error Type': errorType || TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_UNKNOWN,
                'Is IBAN Authentication': isIbanAuthentication,
                'Is NIE': getIsNIE(uniqueTaxpayerReference),
                'Support Number': obscureSensitiveData(supportNumber, { replaceNumbersWith: 0 }),
                'Tax Year': taxYear,
                UTR: obscureSensitiveData(uniqueTaxpayerReference, { replaceNumbersWith: 0 }),
            })

            break
        }

        case TRACK_TAX_RETURN_PROMPT_ADDRESS_CONFIRMATION: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_PROMPT_ADDRESS_CONFIRMATION,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_PROMPT_ADDRESS_CONFIRMATION, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_SUCCESS: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_SUCCESS,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_SUCCESS, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_ERROR: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_ERROR,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_ADDRESS_CONFIRMATION_ERROR, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_MISSING_CADASTRAL_REFERENCE_ERROR: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_MISSING_CADASTRAL_REFERENCE_ERROR,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_MISSING_CADASTRAL_REFERENCE_ERROR, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_COMPLETE_DATA_SYNC: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_COMPLETE_DATA_SYNC,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_COMPLETE_DATA_SYNC, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_SUBMIT: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_SUBMIT,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_SUBMIT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_INITIATE_PAYMENT: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_INITIATE_PAYMENT,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_INITIATE_PAYMENT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_COMPLETE_PAYMENT: {
            const { amount, taxYear, languagePreference } = data

            googleAnalyticsTrack({
                ...data,
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_COMPLETE_PAYMENT,
                label: taxYear,
                value: amount,
                languagePreference,
            })

            mixpanelTrack(TRACK_TAX_RETURN_COMPLETE_PAYMENT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_TAX_RETURN_CANCEL_PAYMENT: {
            const { taxYear } = data

            googleAnalyticsTrack({
                category: CATEGORY_TAX_RETURN,
                action: TRACK_TAX_RETURN_CANCEL_PAYMENT,
                label: taxYear,
            })

            mixpanelTrack(TRACK_TAX_RETURN_CANCEL_PAYMENT, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_INVOICE_CREATE: {
            mixpanelTrack(TRACK_INVOICE_CREATE)

            break
        }

        case TRACK_INVOICE_SAVE: {
            const { id, invoiceNumber } = data

            mixpanelTrack(TRACK_INVOICE_SAVE, {
                'Invoice Number': invoiceNumber,
                invoiceId: id,
            })

            break
        }

        case TRACK_INVOICE_DOWNLOAD: {
            const { id, invoiceNumber } = data

            mixpanelTrack(TRACK_INVOICE_DOWNLOAD, {
                'Invoice Number': invoiceNumber,
                invoiceId: id,
            })

            break
        }

        case TRACK_INVOICE_DELETE: {
            const { id, invoiceNumber } = data

            mixpanelTrack(TRACK_INVOICE_DELETE, {
                'Invoice Number': invoiceNumber,
                invoiceId: id,
            })

            break
        }

        case TRACK_WHATS_NEXT_TOOGGLE:
        case TRACK_WHATS_NEXT_LINK_CLICKED:
        case TRACK_SUBSCRTIPTION_UPDATE: {
            mixpanelTrack(action, data)
            break
        }

        case TRACK_BANKING_BBVA_CTA_CLICK: {
            mixpanelTrack(action)
            break
        }

        default:
            break
    }
}

export const resetTracking = () => {
    mixpanelReset()
}
